import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, CheckCircle } from 'lucide-react';
import { serviceZones, siteConfig } from '../data/mock';

const ZoneSection = () => {
  return (
    <section className="py-20 bg-section">
      <div className="container mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-orange-200 rounded-full mb-6">
              <MapPin className="w-5 h-5 text-accent-orange-400" />
              <span className="font-medium text-primary">Zona de servicio</span>
            </div>
            <h2 className="heading-1 mb-4">{siteConfig.zone}</h2>
            <p className="body-medium text-secondary">
              Ofrezco mis servicios en las siguientes localidades de la comarca del Maresme.
            </p>
          </motion.div>

          {/* Zones grid */}
          <motion.div
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {serviceZones.map((zone, index) => (
              <motion.div
                key={zone}
                className="flex items-center gap-2 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                <span className="font-medium text-primary">{zone}</span>
              </motion.div>
            ))}
          </motion.div>

          {/* Additional note */}
          <motion.p
            className="text-center text-sm text-secondary mt-8"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            ¿No encuentras tu zona? Contáctame y lo hablamos.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default ZoneSection;
